import { createHashRouter, NavigateFunction, RouterProvider } from 'react-router-dom';
import { ApplicationStatusModel } from '@n2-common/serverGeneratedTypings/applicationStatusModel';
import CompletedPage from '@n2-common/applicationPages/CompletedPage';
import { DeclinedPage } from '@n2-common/applicationPages';
import ErrorPage from '@n2-common/applicationPages/ErrorPage';
import WizardApp from './LoanApplicationWizard/LoanApplicationWizard';
import { ReactRouterErrorBoundary } from '@n2-common/applicationPages/ReactRouterErrorBoundary';
import { navigateToStep, ApplicationPaths } from '@n2-common/applicationPages/ApplicationFormsHelpers';
import { PageLayout } from '@n2-common/applicationPages/AppBase/AppBase';
import { N2Product } from '@n2-common/serverGeneratedTypings/n2Product';
import { commonNavigateToCorrectStepForSingleApplicantProducts } from '@n2-common/applicationPages/applicationStatusHelpers';
import { Suspense } from 'react';
import { Spinner } from '@n2-common/ui';
import Status, { getLandingPageLoader } from '@n2-common/applicationPages/Status';
import { N2ApplicationStatus } from '@n2-common/serverGeneratedTypings/n2ApplicationStatus';
import { getLinkKey } from '@n2-common/applicationPages/DeclinedWithLink';
import { Channel } from '@n2-common/serverGeneratedTypings/channel';
import { getChannel } from '@n2-common/lib/serverSideConfigs';

export const navigateToCorrectStep = (application: ApplicationStatusModel, applicantId: string, navigate: NavigateFunction) => {
    if (application.Product !== N2Product.Loan) {
        console.log('product is not Loan, navigating to notfound');
        navigateToStep(ApplicationPaths.notFound, application.ApplicationId, navigate, applicantId);
        return;
    }
    return commonNavigateToCorrectStepForSingleApplicantProducts(application, applicantId, navigate);
};

export const App = ({ antiforgeryToken }: { antiforgeryToken: string | undefined }) => {
    const channel = getChannel() as Channel;

    const loanFiRouter = createHashRouter([
        {
            element: <PageLayout productType="CLA" channel={channel} country="FI" antiforgeryToken={antiforgeryToken} versionApp="" />,
            children: [
                {
                    path: ApplicationPaths.wizard,
                    element: <WizardApp />,
                },
                {
                    path: ApplicationPaths.declined,
                    loader: getLandingPageLoader('DeclinedWithLink' as N2ApplicationStatus),
                    element: <Status linkKey={getLinkKey('FI')} />,
                },
                {
                    path: ApplicationPaths.declinedFromAgent,
                    element: <DeclinedPage navigateToCorrectStepFunc={navigateToCorrectStep} />,
                },
                {
                    path: ApplicationPaths.canceled,
                    loader: getLandingPageLoader('Canceled' as N2ApplicationStatus), //There is a spelling error in enumvalue :-(
                    element: <Status />,
                },
                {
                    path: ApplicationPaths.completed,
                    element: <CompletedPage navigateToCorrectStepFunc={navigateToCorrectStep} />,
                },
                {
                    path: ApplicationPaths.error,
                    element: <ErrorPage />,
                },
            ],
            errorElement: <ReactRouterErrorBoundary />,
        },
    ]);

    return (
        <Suspense fallback={<Spinner text="Loading page..." />}>
            <RouterProvider router={loanFiRouter} />
        </Suspense>
    );
};
